import styled from 'styled-components';

export const Item = styled.label`
	display: block;
	padding-bottom: 5px;
`;

export const ItemValue = styled(Item)`
	font-weight: bold;
`;

export const ContainerChart = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 300px;
`;
